import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-search-products-sceleton',
  templateUrl: './ui-search-products-sceleton.component.html',
  styleUrls: ['./ui-search-products-sceleton.component.scss']
})
export class UiSearchProductsSceletonComponent implements OnInit {
  public categoriesItems = [];
  public categoriesItemsCount = 4;
  public filtersItems = [];
  public filtersItemsCount = 5;

  constructor() {
  }

  ngOnInit() {
    this.categoriesItems = this._getItemsArray(this.categoriesItemsCount);
    this.filtersItems = this._getItemsArray(this.filtersItemsCount);
  }

  private _getItemsArray(count: number) {
    const result = [];

    for (let i = 1; i <= count; i++) {
      result.push(i);
    }

    return result;
  }
}
